import { render, staticRenderFns } from "./SupplierDetailsSection.vue?vue&type=template&id=3c502695&"
import script from "./SupplierDetailsSection.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports